module.exports = __webpack_public_path__ + "static/media/1.e856f6d2.jpg";